import React, { useState, useEffect, useCallback, useRef } from "react";
import AppContext from ".";
import AsyncStorage from "@react-native-community/async-storage";
import { debounce } from "lodash";
import { DeviceEventEmitter, Platform } from "react-native";
import Axios from "axios";

const ContextProvider = ({ children }) => {
  const [settings, _setSettings] = useState({
    vibrate: true,
    onAudioEnd: "go-back-to-map",
  });
  const [tour, setTour] = useState(null);
  const [stop, setStop] = useState(-1);
  const [mapId, setMapId] = useState(-1);
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [audioPlaying, setAudioPlaying] = useState(false);
  const [audioFromCard, setAudioFromCard] = useState(-1);

  const [tours, setTours] = useState([]);

  const [geolocationAvailable, setGeolocationAvailable] = useState(false);
  const [gameMenuHeight, _setGameMenuHeight] = useState(500);

  const [inGameStats, setInGameStats] = useState(false);
  const [pickedPlace, setPickedPlace] = useState({ country: {}, cityID: -1 });
  const [allPlaces, _setAllPlaces] = useState({});
  const [favoriteTours, _setFavoriteTours] = useState([]);
  const [cities, _setCities] = useState({});
  const [countries, _setCountries] = useState({});
  const [downloads, setDownloads] = useState({});
  const [user, _setUser] = useState(null);
  const [dict, setDict] = useState({});
  const [lang, setLang] = useState("en");
  const [generalModal, setGeneralModal] = useState(null);

  const tourRef = useRef(null);

  const removeListener = useRef(null);
  const playingRef = useRef(null);
  const [cloudTours, setCloudTours] = useState({});
  const [offlineTours, setOfflineTours] = useState({});

  const save = () => {
    // console.log('SAVING DISABLED.');
    //console.log('SAVE', tourRef.current);
    if (tourRef.current) {
      AsyncStorage.setItem(
        "progress-" + tourRef.current.encryptTourID,
        JSON.stringify(tourRef.current)
      );
    }
  };
  const handler = useCallback(debounce(save, 1500), []);

  useEffect(() => {
    AsyncStorage.getItem("settings").then((d) => {
      if (d) setSettings(JSON.parse(d));
    });
    AsyncStorage.getItem("favoriteTours").then((d) => {
      if (d) setFavoriteTours(JSON.parse(d));
    });

    AsyncStorage.getItem("loginData").then((d) => {
      if (d) {
        Axios.defaults.headers.Authorization = `Bearer ${
          JSON.parse(d).access_token
        }`;
        AsyncStorage.getItem("user").then((dd) => {
          if (dd) {
            _setUser(JSON.parse(dd));
          }
        });
        Axios("https://api3.guidigo.com/user/UserData")
          .then((dd) => {
            //console.log('FRESH USER DATA', dd.data);
            _setUser(dd.data);
            AsyncStorage.setItem("user", JSON.stringify(dd.data));
          })
          .catch((e) => {
            logOut();
          });
      }
    });

    initPlaces();
  }, []);

  useEffect(() => {
    tourRef.current = tour;
    handler();
  }, [tour]);

  const setSettings = (s) => {
    _setSettings(s);
    AsyncStorage.setItem("settings", JSON.stringify(s));
  };

  const setGameMenuHeight = (h) => {
    if (Platform.OS !== "web") _setGameMenuHeight(Math.max(400, h));
    else _setGameMenuHeight(window.innerHeight - 120);
  };

  const setFavoriteTours = (s) => {
    _setFavoriteTours(s);
    AsyncStorage.setItem("favoriteTours", JSON.stringify(s));
  };

  const resolveURL = (type, file, size) => {
    switch (type) {
      case "image":
      case "game":
      case "panoramas":
        return `https://api3.guidigo.com/Media/Image/${file}/publish/${size}`;

      case "audio":
      case "game-audio":
        return `https://api3.guidigo.com/Media/Audio/${file}`;
      //return Platform.OS === 'android' ? `https://api3.guidigo.com/Media/Audio/${file}` : `https://www.guidigo.com/Blob/Audio?filename=${file}`  ;

      case "video":
        //  console.log( `https://api3.guidigo.com/Media/Video/${file}`)
        return `https://api3.guidigo.com/Media/Video/${file}`;
      //return Platform.OS === 'android' ? `https://api3.guidigo.com/Media/Video/${file}` :`https://www.guidigo.com/Blob/Video/${file}`  ;
      case "map":
        return `https://api3.guidigo.com/Media/Slice/${file}/thumb/{z}/{x}/{y}`;
      default:
        return "";
    }
  };

  const logIn = (u) => {
    //console.log('Log IN:', u);
    if (u) {
      AsyncStorage.setItem("loginData", JSON.stringify(u));
      Axios.defaults.headers.Authorization = `Bearer ${u.access_token}`;
      Axios("https://api3.guidigo.com/user/UserData").then((d) => {
        //console.log('USER DATA', d.data);
        _setUser(d.data);
        AsyncStorage.setItem("user", JSON.stringify(d.data));
      });
    }
  };

  const logOut = () => {
    //console.log('LOG OUT');
    AsyncStorage.multiRemove(["loginData", "user"]);
    delete Axios.defaults.headers.Authorization;
    _setUser(null);
  };

  const setCities = (_cities) => {
    _setCities(_cities);
    AsyncStorage.setItem("cities", JSON.stringify(_cities));
  };

  const setCountries = (_countries) => {
    _setCountries(_countries);
    AsyncStorage.setItem("countries", JSON.stringify(_countries));
  };

  const setAllPlaces = (_allPlaces) => {
    _setAllPlaces(_allPlaces);
    AsyncStorage.setItem("allPlaces", JSON.stringify(_allPlaces));
  };

  const initPlaces = () => {
    AsyncStorage.multiGet(["cities", "countries", "allPlaces"]).then((d) => {
      // console.log('Cities', d[0][1]);
      // console.log('Countries', d[1][1]);
      // console.log('allPlaces', d[2][1]);
      if (d[0][1]) setCities(JSON.parse(d[0][1]));
      if (d[1][1]) setCountries(JSON.parse(d[1][1]));
      if (d[2][1]) setAllPlaces(JSON.parse(d[2][1]));
    });
  };

  function getCurrentRouteName(navigationState) {
    if (!navigationState) {
      return null;
    }
    const route = navigationState.routes[navigationState.index];
    // dive into nested navigators
    if (route.routes) {
      return getCurrentRouteName(route);
    }
    return route.name;
  }

  const context = {
    settings,
    setSettings,
    tour,
    setTour,
    stop,
    setStop,
    location,
    setLocation,
    tours,
    setTours,
    audioPlaying,
    setAudioPlaying,
    audioFromCard,
    setAudioFromCard,
    geolocationAvailable,
    setGeolocationAvailable,
    gameMenuHeight,
    setGameMenuHeight,
    inGameStats,
    setInGameStats,
    pickedPlace,
    setPickedPlace,
    allPlaces,
    setAllPlaces,
    favoriteTours,
    setFavoriteTours,
    setCities,
    cities,
    setCountries,
    countries,
    mapId,
    setMapId,
    downloads,
    setDownloads,
    resolveURL,
    user,
    logIn,
    logOut,
    dict,
    setDict,
    lang,
    setLang,
    generalModal,
    setGeneralModal,
    cloudTours,
    setCloudTours,
    offlineTours,
    setOfflineTours,
  };

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export default ContextProvider;
